"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var react_redux_1 = require("react-redux");

var pricing_experience_navigation_1 = require("./pricing-experience-navigation");

var pricing_experience_navigator_connected_1 = require("./pricing-experience-navigator/pricing-experience-navigator.connected");

var pricing_experience_router_connected_1 = require("./pricing-experience-router/pricing-experience-router.connected");

var store_1 = require("./store/store");

var PricingExperience = function (_super) {
  __extends(PricingExperience, _super);

  function PricingExperience(props) {
    var _this = _super.call(this, props) || this;

    _this.setPricingExperienceNavigationStore = function () {
      pricing_experience_navigation_1.PricingExperienceNavigation.store = _this.store;
    };

    _this.store = store_1.buildPricingExperienceStore();
    return _this;
  }

  PricingExperience.prototype.render = function () {
    return react_1.default.createElement(react_redux_1.Provider, {
      store: this.store
    }, react_1.default.createElement(pricing_experience_router_connected_1.ConnectedPricingExperienceRouter, {
      onStateChange: this.setPricingExperienceNavigationStore,
      scenes: pricing_experience_navigator_connected_1.ConnectedPricingExperienceNavigator
    }));
  };

  return PricingExperience;
}(react_1.default.Component);

exports.PricingExperience = PricingExperience;